import { I18NService, II18NRepo, I18NRepo, TestI18NRepo } from './eighteen';
import { AlertsService } from './alerts';
import { RestSearchService } from './restSearch/restSearch.service';
import { IRestSearch } from './restSearch/irestSearch.repo';
import { RestSearchRepo } from './restSearch/restSearch.repo';
import { TestRestSearchRepo } from './restSearch/restSearch.test.repo';

// injectables only in here
export class DirectiveProviderFactory {
	addProviderTypes(dependencies: any[], useTest = false) {
		dependencies.push({ provide: II18NRepo, useClass: useTest ? TestI18NRepo : I18NRepo });
		dependencies.push({ provide: I18NService, useClass: I18NService });
		dependencies.push({ provide: AlertsService, useClass: AlertsService });
		dependencies.push({ provide: RestSearchService, useClass: RestSearchService });
		if (useTest) {
			dependencies.push({ provide: IRestSearch, useClass: TestRestSearchRepo });
		} else {
			dependencies.push({ provide: IRestSearch, useClass: RestSearchRepo });
		}
	}
}
